export interface IShowHideCatalogo {
  mostrarEditar: boolean;
  mostrarNuevo: boolean;
  guardando: boolean;
}

export interface IShowHideCatalogos {
  usuarios: IShowHideCatalogo;
  empresas: IShowHideCatalogo;
  tipos: IShowHideCatalogo;
  remitentes: IShowHideCatalogo;
  modosEntrada: IShowHideCatalogo;
}

export const InnitShowHideCatalogos: IShowHideCatalogos = {
  usuarios: {
    mostrarEditar: false,
    mostrarNuevo: false,
    guardando: false,
  },
  empresas: {
    mostrarEditar: false,
    mostrarNuevo: false,
    guardando: false,
  },
  tipos: {
    mostrarEditar: false,
    mostrarNuevo: false,
    guardando: false,
  },
  remitentes: {
    mostrarEditar: false,
    mostrarNuevo: false,
    guardando: false,
  },
  modosEntrada: {
    mostrarEditar: false,
    mostrarNuevo: false,
    guardando: false,
  },
};
